// extracted by mini-css-extract-plugin
export var hero = "styles-module--hero--1NwkQ";
export var imgContainer = "styles-module--imgContainer--pXR95";
export var hero_img = "styles-module--hero_img--ZUSJs";
export var hero_inner = "styles-module--hero_inner--alve7";
export var hero_txt = "styles-module--hero_txt--ehDw3";
export var hero_txt_suptitle = "styles-module--hero_txt_suptitle--28jN5";